var render = function () {
  var _class, _class2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('masked-input', {
    class: (_class = {}, _class[_vm.$style.field] = true, _class[_vm.$style.invalid] = _vm.isInvalid, _class[_vm.$style.spacing] = _vm.$slots.hasOwnProperty('link'), _class),
    attrs: {
      "id": _vm.inputId,
      "type": "text",
      "mask": _vm.mask,
      "placeholder": _vm.$props.placeholder,
      "disabled": _vm.disabled
    },
    on: {
      "blur": _vm.onValidate,
      "change": function change($event) {
        return _vm.$emit('change', $event);
      }
    },
    model: {
      value: _vm.internalValue,
      callback: function callback($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  }), _c('label', {
    class: (_class2 = {}, _class2[_vm.$style.label] = true, _class2[_vm.$style.spacing] = _vm.isInvalid || _vm.disabled, _class2),
    attrs: {
      "for": _vm.inputId
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]), _c('div', {
    class: _vm.$style.attachmentContainer
  }, [_c('div', {
    class: _vm.$style.attachmentPosition
  }, [_c('div', {
    class: _vm.$style.icons
  }, [_vm.disabled ? _c('div', {
    class: _vm.$style.lockCircleIcon
  }, [_c('lock-circle-icon')], 1) : _vm._e(), _vm.isInvalid ? _c('div', {
    class: _vm.$style.alertCircleIcon
  }, [_c('alert-circle-icon')], 1) : _vm._e()]), _vm.$slots.hasOwnProperty('link') ? _c('div', {
    class: _vm.$style.link
  }, [_vm._t("link")], 2) : _vm._e()]), _vm.$slots.hasOwnProperty('composite') ? _c('div', {
    class: _vm.$style.attachmentComposite
  }, [_vm._t("composite")], 2) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }